// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "main.middle-school-react" + "." + "6f1522d89c6422339a46" + ".css";
};